import React, { lazy, Suspense, useState, useEffect } from "react";
import { getLBUIdentifier } from "../../../../utils/common-utils";
import { CircularProgress } from "@mui/material";
import { color } from "../../../../mui-theme/palette";

// Props for LoginForm
interface LoginFormProps {
  region: any;
  setRegion: (region: any) => void;
  phoneNumber: string;
  setPhoneNumber: (phone: string) => void;
  password: string;
  setPassword: (password: string) => void;
  handleLogin: () => void;
  handleForgetPassword: () => void;
  t: (key: string) => string;
  // PHKL Custom -s
  userId: string;
  setUserId: (userId: any) => void;
  handleCreateAccount: () => void;
  handleDisclaimerClick: () => void;
  handlePrivacyPolicyClick: () => void;
  // PHKL Custom -e
}

export const DynamicLoginForm: React.FC<LoginFormProps> = (props) => {
  const [Component, setComponent] = useState<React.LazyExoticComponent<any> | null>(null);

  // useEffect(() => {
  //   const lbu = getLBUIdentifier();
  //   // Dynamically import the component
  //   const loadComponent = async () => {
  //     try {
  //       const path = lbu === "coe" ? "./login-form" : `./${lbu}/login-form`;
  //       const module = await import(path);
  //       setComponent(() => React.lazy(() => Promise.resolve({ default: module.default })));
  //     } catch (error) {
  //       console.log(`Failed to load component for LBU: ${lbu}, falling back to default.`, error);
  //       const defaultModule = await import("./login-form");
  //       setComponent(() => React.lazy(() => Promise.resolve({ default: defaultModule.default })));
  //     }
  //   };

  //   loadComponent();
  // }, []);
  // PHKL Custom -s
  useEffect(() => {
    let isMounted = true;
    const lbu = getLBUIdentifier();
    // Dynamically import the component
    // The original method dynamically imports the address, which may cause the path not to be found.
    const loadComponent = async () => {
      try {
        let LazyComponent: any;
        switch (lbu) {
          case "coe":
          case "default":
            LazyComponent = React.lazy(() => import("./login-form"));
            break;
          default:
            // Since our website does not include /public/hk, we will hard code "hk" first.
            // LazyComponent = React.lazy(() => import(`./${lbu}/login-form`));
            LazyComponent = React.lazy(() => import(`./hk/login-form`));
            break;
        }
        if (isMounted) {
          setComponent(() => LazyComponent);
        }
      } catch (error) {
        console.log(`Failed to load component for LBU: ${lbu}, falling back to default.`, error);
        const FallbackComponent = React.lazy(() => import("./login-form"));
        if (isMounted) {
          setComponent(() => FallbackComponent);
        }
      }
    };

    loadComponent();

    return () => {
      isMounted = false;
    };
  }, []);
  // PHKL Custom -e
  if (!Component) {
    return (
      <div className="w-full items-center">
        <CircularProgress sx={{ color: color.majorRed }} />
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="w-full items-center">
          <CircularProgress sx={{ color: color.majorRed }} />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );
};
